module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-intro page",
    attrs: {
      "id": "page-intro"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("Een hybride auto ken je")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "page-intro__text-1"
    }
  }, [_vm._v("Een voertuig dat door een combinatie van twee krachtbronnen...")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    attrs: {
      "id": "page-intro__text-2"
    }
  }, [_vm._v("... wordt aangedreven")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-intro__next-btn"
    }
  }, [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animation-area",
    attrs: {
      "id": "page-intro__animation-area"
    }
  }, [_c('div', {
    staticClass: "animation-area__center"
  }, [_c('img', {
    staticClass: "page-intro__animated-item",
    attrs: {
      "id": "page-intro__fuel",
      "src": require("../../assets/icons/fuel tank.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-intro__animated-item",
    attrs: {
      "id": "page-intro__plus",
      "src": require("../../assets/icons/plus.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-intro__animated-item",
    attrs: {
      "id": "page-intro__plug",
      "src": require("../../assets/icons/plug.svg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d4a0a36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-intro.vue
// module id = 145
// module chunks = 0